<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{ (data?.id?'title.update-record':'title.new-record') | translate}}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()">

  </button>
</div>

<div class="modal-body">
  <!-- Güncelleme  -->
  <div>
    <form #createForm="ngForm" class="needs-validation" novalidate>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <!-- Sms Firması -->
              <div class="form-group">
                <label class="custom-form-label" for="voipId">{{'voip.name' | translate}}</label>
                <select name="voipId" [(ngModel)]="data.voipId" class="form-control" required>
                  <option *ngFor="let option of voips" [ngValue]="option.id">
                    {{ option.name }}
                  </option>
                </select>
              </div>

              <!-- Ad-->
              <div class="form-group">
                <label class="custom-form-label" for="name">{{'voip.voipInternal' | translate}}</label>
                <input #name="ngModel" type="text" class="form-control" name="name" [(ngModel)]="data.name" appUppercase required [class.is-invalid]="name.invalid && name.touched" ngbAutoFocus />
                <app-field-error-display [displayError]="name.invalid && name.touched" errorMsg="{{'message.error.cannot-be-blank' | translate}}">
                </app-field-error-display>
              </div>

              <!-- internalNo -->
              <div class="form-group">
                <label class="custom-form-label" for="internalNo">{{'voip.internalNo' | translate}}</label>
                <input #internalNo="ngModel" type="text" class="form-control" name="internalNo" [(ngModel)]="data.internalNo" [class.is-invalid]="internalNo.invalid && internalNo.touched"
                  autocompleteOff />
              </div>

              <!-- internalNoForStartingCall -->
              <div class="form-group">
                <label class="custom-form-label" for="internalNoForStartingCall">{{'voip.internalNoForStartingCall' | translate}}</label>
                <input #internalNoForStartingCall="ngModel" type="text" class="form-control" name="internalNoForStartingCall" [(ngModel)]="data.internalNoForStartingCall"
                  [class.is-invalid]="internalNoForStartingCall.invalid && internalNoForStartingCall.touched" autocompleteOff />
              </div>
              <div class="col">
                <label class="custom-form-label" for="callTypeInput">{{'voip.callType' | translate}}</label>
                <select #callTypeInput name="callTypeInput" class="form-control input-lg" [(ngModel)]="data.callType" required>
                  <option *ngFor="let item of voipCallTypeEnumValues" [ngValue]="item">{{ 'voipCallTypeValue.'+item |
                    translate}}
                  </option>
                </select>
              </div>

              <!-- Aktif mi -->
              <div class="form-group form-check form-switch">
                <input #status="ngModel" type="checkbox" class="form-check-input" name="status" id="status" [(ngModel)]="isActive" />
                <label class="form-check-label" for="status">{{'common.isActive' | translate}}</label>
              </div>

            </div>
            <div class="col-md-6">
              <!-- userName -->
              <div class="form-group">
                <label class="custom-form-label" for="userName">{{'voipInternal.userName' | translate}}</label>
                <input #userName="ngModel" type="text" class="form-control" name="userName" [(ngModel)]="data.userName" required [class.is-invalid]="userName.invalid && userName.touched"
                  autocomplete="new-username" />
                <app-field-error-display [displayError]="userName.invalid && userName.touched" errorMsg="{{'message.error.cannot-be-blank' | translate}}">
                </app-field-error-display>
              </div>

              <div class="col">
                <label class="custom-form-label" for="password">{{'voipInternal.password' | translate}}</label>
                <div class="input-group">
                  <input #password="ngModel" class="form-control" name="password" [(ngModel)]="data.password" [type]="fieldTextType ? 'text' : 'password'" required
                    [class.is-invalid]="password.invalid && password.touched" autocomplete="new-password" />
                  <app-field-error-display [displayError]="password.invalid && password.touched" errorMsg="{{'message.error.cannot-be-blank' | translate}}">
                  </app-field-error-display>
                  <div class="input-group-append">
                    <span class="input-group-text">
                      <i class="fa" [ngClass]="{'fas fa-eye-slash': !fieldTextType,'fas fa-eye': fieldTextType }" (click)="fieldTextType=!fieldTextType"></i>
                    </span>
                  </div>
                </div>
              </div>





            </div>

          </div>




        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">
    {{'button.close' | translate}}
  </button>

  <button type="button" [disabled]="createForm.form.invalid" class="btn btn-primary" (click)="save()">
    {{'button.save' | translate}}
  </button>
</div>